import React, {Component} from 'react';
import {Button, Card, CardBody, CardTitle, Col, Form, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Colxx, Separator} from '../components/common/CustomBootstrap';
import Skeleton from 'react-loading-skeleton';
import Api from '../services/Api';
import {i18nizeDate, numberWithCommas, selectStyles, sleep} from '../helpers/Utils';
import {isEqual, keyBy, values, isNull, map} from 'lodash';
import SecurityVerificationForm from './SecurityVerificationForm';
import {NotificationManager} from '../components/common/react-notifications';
import ModalManager from '../components/modal/ModalManager';
import {baseTokenSymbol} from '../constants/configs';
import TextField from '../components/TextField';
import LoaderButton from '../components/LoaderButton';
import {Form as FinalForm} from 'react-final-form';
import ToolTip from '../components/ToolTip';
import Rbac from '../components/Rbac';
import Select from 'react-select';
import Switch from 'react-switch';

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {...props.info};
  }

  async componentDidMount() {
    await this.fetchData();
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.info, this.state)) {
      this.setState({
        ...nextProps.info,
      });
    }
  }

  fetchData = async () => {
    await Promise.all([
      Rbac.hasPermission('view_user-groups') ? this.fetchUserGroups() : null,
      Rbac.hasPermission('view_policies') ? this.fetchKycPolicies() : null,
      Rbac.hasPermission('view_policies') ? this.fetchLoyaltyPolicies() : null,
      Rbac.hasPermission('view_special-tokens-list') ? this.fetchSpecialTokens() : null,
      Rbac.hasPermission('view_special-pairs-list') ? this.fetchSpecialPairs() : null,
      Rbac.hasPermission('view_user-special-tokens') ? this.fetchUserSpecialTokens() : null,
      Rbac.hasPermission('view_user-special-pairs') ? this.fetchUserSpecialPairs() : null,
    ]);
  };

  fetchSpecialTokens = async () => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/special-tokens-list');
      this.setState({
        ...this.state,
        specialTokens: data,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchSpecialPairs = async () => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/special-pairs-list');
      this.setState({
        ...this.state,
        specialPairs: data,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchUserSpecialTokens = async () => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/user-special-tokens', null, {
        params: {
          userId: this.state.id,
        }
      });
      this.setState({
        ...this.state,
        userSpecialTokens: data,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchUserSpecialPairs = async () => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/user-special-pairs', null, {
        params: {
          userId: this.state.id,
        }
      });
      this.setState({
        ...this.state,
        userSpecialPairs: data,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  onChangeUserSpecialTokens = async specialTokens => {
    const {t} = this.props;
    try {
      await Api.invoke('PUT', '/admin-ui/user-special-tokens', {
        userId: this.state.id,
        specialTokens: map(specialTokens, 'value'),
      });
      this.setState({
        ...this.state,
        userSpecialTokens: map(specialTokens, 'value'),
      });
      NotificationManager.success(t('User special tokens updated successfully'), t('Message'));
    } catch (e) {
      console.log('error: ', e);
    }
  };

  onChangeUserSpecialPairs = async specialPairs => {
    const {t} = this.props;
    try {
      await Api.invoke('PUT', '/admin-ui/user-special-pairs', {
        userId: this.state.id,
        specialPairs: map(specialPairs, 'value'),
      });
      this.setState({
        ...this.state,
        userSpecialPairs: map(specialPairs, 'value'),
      });
      NotificationManager.success(t('User special pairs updated successfully'), t('Message'));
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchUserGroups = async () => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/user-groups', null, {
        params: {limit: 100}
      });
      this.setState({
        ...this.state,
        userGroups: keyBy(data.userGroups, 'id'),
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchKycPolicies = async () => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/kyc-policies', null, {
        params: {limit: 100}
      });
      this.setState({
        ...this.state,
        kycPolicies: data.policies,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchLoyaltyPolicies = async () => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/loyalty-policies', null, {
        params: {limit: 100}
      });
      this.setState({
        ...this.state,
        loyaltyPolicies: data.policies,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  onSubmitEmail = async values => {
    const {t} = this.props;
    await Api.invoke('PATCH', '/admin-ui/user-email', values);
    NotificationManager.success(t('Email updated successfully'), t('Message'));
    this.setState({
      email: values.email,
      emailConfirmed: true,
    });
  };

  updateEmail = async values => {
    const {t} = this.props;
    const payload = {
      ...values,
      userId: this.state.id,
    };
    const action = 'patch-admin-ui-user-email';
    try {
      const {data} = await Api.invoke('POST', '/admin-ui/access-token', {
        payload: JSON.stringify(payload),
        action,
      });
      ModalManager.close({isOpen: false});
      await sleep(500);
      ModalManager.open({
        isOpen: true,
        title: t('Security Verification'),
        body: this.renderEmailSecurityVerificationForm(action, payload, data),
      });
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  renderEmailSecurityVerificationForm = (action, payload, accessData) => {
    return (
      <SecurityVerificationForm
        action={action}
        accessData={accessData}
        onSubmit={async values => {
          await this.onSubmitEmail({
            ...payload,
            ...values,
          });
        }}
      />
    );
  };

  onClickEmail = () => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Edit Email'),
      body:
        <FinalForm
          onSubmit={this.updateEmail}
          initialValues={{email: this.state.email}}
          render={({handleSubmit, submitting, pristine}) => {
            return (
              <Form>
                <Row>
                  <Col>
                    <TextField item={{
                      name: 'email',
                      i18n: t('Email'),
                      type: 'text',
                    }}/>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col>
                    <LoaderButton
                      color="success"
                      onClick={handleSubmit}
                      loading={submitting}
                      disabled={pristine || submitting}
                      className="text-center"
                      style={{minWidth: '100px'}}>
                      {t('Save')}
                    </LoaderButton>
                    <Button
                      color="grey"
                      onClick={() =>{
                        ModalManager.close({
                          isOpen: false
                        });
                      }}
                      className="text-center mx-2"
                      style={{minWidth: '100px'}}>
                      {t('Close')}
                    </Button>
                  </Col>
                </Row>
              </Form>
            );
          }}
        />,
    });
  };

  onChangeSmsAuth = async enabled => {
    const {t} = this.props;
    this.setState({
      authStatus: {
        ...this.state.authStatus,
        smsAuthEnabled: enabled,
      },
    });
    try {
      await Api.invoke(
        'POST',
        enabled ? '/admin-ui/enable-user-sms-auth' : '/admin-ui/disable-user-sms-auth',
        {userId: this.state.id},
      );
      NotificationManager.success(
        enabled ? t('SMS authenticate enabled successfully') : t('SMS authenticate disabled successfully'),
        t('Message')
      );
    } catch (e) {
      this.setState({
        authStatus: {
          ...this.state.authStatus,
          smsAuthEnabled: !enabled,
        },
      });
      console.log('error: ', e);
    }
  };

  getCryptoLimits() {
    const {userGroup, kycLevel} = this.state;
    const {kyc_policy} = userGroup.attributes;
    return {
      deposit: kyc_policy.levels[kycLevel-1].crypto.deposit,
      withdraw: kyc_policy.levels[kycLevel-1].crypto.withdraw,
    };
  }

  getFiatLimits() {
    const {userGroup, kycLevel} = this.state;
    const {kyc_policy} = userGroup.attributes;
    return {
      deposit: kyc_policy.levels[kycLevel-1].fiat.deposit,
      withdraw: kyc_policy.levels[kycLevel-1].fiat.withdraw,
    };
  }

  onSubmitDisableGoogleAuth = async values => {
    const {t} = this.props;
    this.setState({
      authStatus: {
        ...this.state.authStatus,
        googleAuthEnabled: false,
      },
    });
    try {
      await Api.invoke('POST', '/admin-ui/disable-user-google-auth', values);
      NotificationManager.success(t('Google authenticate disabled successfully'), t('Message'));
    } catch (e) {
      this.setState({
        authStatus: {
          ...this.state.authStatus,
          googleAuthEnabled: true,
        },
      });
      throw e;
    }
  };

  onChangeGoogleAuth = async enabled => {
    const {t} = this.props;
    if (enabled) {
      NotificationManager.warning(t('It is not possible to enable google authenticate'), t('Message'));
    } else {
      const payload = {
        userId: this.state.id,
      };
      const action = 'post-admin-ui-disable-user-google-auth';
      try {
        const {data} = await Api.invoke('POST', '/admin-ui/access-token', {
          payload: JSON.stringify(payload),
          action,
        });
        ModalManager.close({isOpen: false});
        await sleep(500);
        ModalManager.open({
          isOpen: true,
          title: t('Security Verification'),
          body: this.renderGoogleAuthSecurityVerificationForm(action, payload, data),
        });
      } catch (e) {
        console.log('error: ', e);
      }
    }
  };

  renderGoogleAuthSecurityVerificationForm = (action, payload, accessData) => {
    return (
      <SecurityVerificationForm
        action={action}
        accessData={accessData}
        onSubmit={async values => {
          await this.onSubmitDisableGoogleAuth({
            ...payload,
            ...values,
          });
        }}
      />
    );
  };

  onChangeOrderRegistrationStatus = async enabled => {
    const {t} = this.props;
    this.setState({
      orderRegistrationEnabled: enabled,
    });
    try {
      await Api.invoke(
        'PATCH',
        '/admin-ui/user-settings',
        {
          userId: this.state.id,
          orderRegistrationEnabled: enabled,
        },
      );
      if (enabled) {
        NotificationManager.success(t('Order registration enabled successfully'), t('Message'));
      } else {
        NotificationManager.success(t('Order registration disabled successfully'), t('Message'));
      }
    } catch (e) {
      this.setState({
        orderRegistrationEnabled: !enabled,
      });
      console.log('error: ', e);
    }
  };

  onChangeBlockStatus = async blocked => {
    const {t} = this.props;
    this.setState({
      blocked
    });
    try {
      await Api.invoke('POST', blocked ? '/admin-ui/user-block' : '/admin-ui/user-unblock', {
        userId: this.state.id,
      });
      if (blocked) {
        NotificationManager.success(t('User blocked successfully'), t('Message'));
      } else {
        NotificationManager.success(t('User unblocked successfully'), t('Message'));
      }
    } catch (e) {
      this.setState({
        blocked: !blocked,
      });
      console.log('error: ', e);
    }
  };

  onChangeWithdrawStatus = async enabled => {
    const {t} = this.props;
    this.setState({
      withdrawEnabled: enabled,
    });
    try {
      await Api.invoke(
        'PATCH',
        '/admin-ui/user-settings',
        {
          userId: this.state.id,
          withdrawEnabled: enabled,
        },
      );
      if (enabled) {
        NotificationManager.success(t('Withdraw status enabled successfully'), t('Message'));
      } else {
        NotificationManager.success(t('Withdraw status disabled successfully'), t('Message'));
      }
    } catch (e) {
      this.setState({
        withdrawEnabled: !enabled,
      });
      console.log('error: ', e);
    }
  };

  onChangeWithdrawWhitelistStatus = async enabled => {
    const {t} = this.props;
    this.setState({
      withdrawWhitelistEnabled: enabled,
    });
    try {
      await Api.invoke(
        'PATCH',
        '/admin-ui/user-settings',
        {
          userId: this.state.id,
          withdrawWhitelistEnabled: enabled,
        },
      );
      if (enabled) {
        NotificationManager.success(t('Crypto withdraw whitelist status enabled successfully'), t('Message'));
      } else {
        NotificationManager.success(t('Crypto withdraw whitelist status disabled successfully'), t('Message'));
      }
    } catch (e) {
      this.setState({
        withdrawWhitelistEnabled: !enabled,
      });
      console.log('error: ', e);
    }
  };

  onChangeWithdrawRiskAfterDepositStatus = async enabled => {
    const {t} = this.props;
    this.setState({
      withdrawRiskAfterDepositEnabled: enabled,
    });
    try {
      await Api.invoke(
        'PATCH',
        '/admin-ui/user-settings',
        {
          userId: this.state.id,
          withdrawRiskAfterDepositEnabled: enabled,
        },
      );
      if (enabled) {
        NotificationManager.success(t('Withdraw risk after deposit enabled successfully'), t('Message'));
      } else {
        NotificationManager.success(t('Withdraw risk after deposit disabled successfully'), t('Message'));
      }
    } catch (e) {
      this.setState({
        withdrawRiskAfterDepositEnabled: !enabled,
      });
      console.log('error: ', e);
    }
  };

  onChangeWithdrawRiskManagementStatus = async enabled => {
    const {t} = this.props;
    this.setState({
      withdrawRiskManagementEnabled: enabled,
    });
    try {
      await Api.invoke(
        'PATCH',
        '/admin-ui/user-settings',
        {
          userId: this.state.id,
          withdrawRiskManagementEnabled: enabled,
        },
      );
      if (enabled) {
        NotificationManager.success(t('Withdraw risk management enabled successfully'), t('Message'));
      } else {
        NotificationManager.success(t('Withdraw risk management disabled successfully'), t('Message'));
      }
    } catch (e) {
      this.setState({
        withdrawRiskManagementEnabled: !enabled,
      });
      console.log('error: ', e);
    }
  };

  getLimits = value => {
    const {t} = this.props;
    if (!isNaN(value) && !isNull(value)) {
      return `${numberWithCommas(value)} ${t(baseTokenSymbol)}`;
    } else {
      return t('Infinity');
    }
  };

  onChangeUserGroup = async selected => {
    try {
      const {userGroup, id} = this.state;
      const {t, fetchProfile} = this.props;
      await Api.invoke('PUT', '/admin-ui/user-group', {
        userId: id,
        group: {
          name: selected.value,
          attributes: {
            kyc_policy: userGroup.attributes.kyc_policy.id,
            loyalty_policy: userGroup.attributes.loyalty_policy.id
          }
        },
      });
      fetchProfile();
      NotificationManager.success(t('User group updated successfully'), t('Message'));
    } catch (e) {
      console.log('error: ', e);
    }
  };

  onChangeKycPolicy = async selected => {
    try {
      const {userGroup, id} = this.state;
      const {t, fetchProfile} = this.props;
      await Api.invoke('PUT', '/admin-ui/user-group', {
        userId: id,
        group: {
          name: userGroup.name,
          attributes: {
            kyc_policy: selected.value,
            loyalty_policy: userGroup.attributes.loyalty_policy.id
          }
        },
      });
      fetchProfile();
      NotificationManager.success(t('Kyc policy updated successfully'), t('Message'));
    } catch (e) {
      console.log('error: ', e);
    }
  };

  onChangeLoyaltyPolicy = async selected => {
    try {
      const {userGroup, id} = this.state;
      const {t, fetchProfile} = this.props;
      await Api.invoke('PUT', '/admin-ui/user-group', {
        userId: id,
        group: {
          name: userGroup.name,
          attributes: {
            kyc_policy: userGroup.attributes.kyc_policy.id,
            loyalty_policy: selected.value,
          }
        },
      });
      fetchProfile();
      NotificationManager.success(t('Loyalty policy updated successfully'), t('Message'));
    } catch (e) {
      console.log('error: ', e);
    }
  };

  render() {
    const {t} = this.props;
    const {
      profilePicture,
      firstName,
      lastName,
      email,
      emailConfirmed,
      id,
      createdAt,
      kycLevel,
      userGroup,
      loyaltyLevel,
      tradeFee,
      authStatus,
      lastTransactions,
      withdrawEnabled,
      registeredWith3rdPartyApi,
      orderRegistrationEnabled,
      withdrawRiskManagementEnabled,
      withdrawRiskAfterDepositEnabled,
      withdrawWhitelistEnabled,
      blocked,
      loyaltyPolicies,
      kycPolicies,
      userGroups,
      specialTokens,
      specialPairs,
      userSpecialTokens,
      userSpecialPairs,
    } = this.state;
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="text-large text-primary">
                {t('User Account Stats')}
              </CardTitle>
              <Row>
                {typeof profilePicture !== 'undefined' ?
                  <img
                    alt="avatar"
                    className="avatar"
                    src={profilePicture ? profilePicture : '/assets/img/sample-avatar.jpg'}
                  />
                  :
                  <Skeleton circle={true} width={120} height={120} />
                }
                <Col className="user-base-info text-one mx-2">
                  <Row>
                    <span className="font-weight-medium">{firstName ? `${firstName} ${lastName}` : <Skeleton width={100} />}</span>
                    <span className="text-black-50 mx-1">{`[${t('id')}: ${id}]`}</span>
                  </Row>
                  <Row className="text-black-50">
                    {email ?
                      <div className='cursor-pointer d-flex flex-row' onClick={Rbac.hasPermission('update_email') ? this.onClickEmail : null}>
                        <div>
                          <span>{email}</span>
                          <span className={emailConfirmed ? 'text-success' : 'text-danger'}>
                            {typeof emailConfirmed !== 'undefined' ?
                              ` (${ emailConfirmed ? t('confirmed') : t('not confirmed')})` :
                              <Skeleton width={50} />
                            }
                          </span>
                        </div>
                        {Rbac.hasPermission('update_email') && <i className='icon-Pencil text-primary mx-2'/>}
                      </div> :
                      <Skeleton width={150} />
                    }
                  </Row>
                </Col>
              </Row>
              <Separator className="my-4"/>
              <Row className="user-account-info d-flex flex-row text-medium mx-1">
                <div className="d-flex flex-column flex-1">
                  {!!registeredWith3rdPartyApi && <Row className="mb-2">
                    <Col className='text-info text-one font-weight-semibold'>
                      ** {t('User is third party registered')}
                    </Col>
                  </Row>}
                  <Row className="mb-2">
                    <Col className="text-black-50">{`${t('Registration Date')}: `}</Col>
                    <Col>{createdAt ? i18nizeDate(createdAt) : <Skeleton width={80} />}</Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{`${t('KYC Level')}: `}</Col>
                    <Col>{kycLevel ? numberWithCommas(kycLevel) : <Skeleton width={60} />}</Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{`${t('Fiat Trade Fee Level')}: `}</Col>
                    <Col>{loyaltyLevel ? numberWithCommas(loyaltyLevel.fiat) : <Skeleton width={60} />}</Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{`${t('Crypto Trade Fee Level')}: `}</Col>
                    <Col>{loyaltyLevel ? numberWithCommas(loyaltyLevel.fiat) : <Skeleton width={60} />}</Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{`${t('Fiat Maker Fee')}: `}</Col>
                    <Col>{tradeFee ? numberWithCommas(tradeFee.fiat.maker_fee) : <Skeleton width={60} />}</Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{`${t('Fiat Taker Fee')}: `}</Col>
                    <Col>{tradeFee ? numberWithCommas(tradeFee.fiat.taker_fee) : <Skeleton width={60} />}</Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{`${t('Crypto Maker Fee')}: `}</Col>
                    <Col>{tradeFee ? numberWithCommas(tradeFee.crypto.maker_fee) : <Skeleton width={60} />}</Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{`${t('Crypto Taker Fee')}: `}</Col>
                    <Col>{tradeFee ? numberWithCommas(tradeFee.crypto.taker_fee) : <Skeleton width={60} />}</Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{`${t('30days Trades Value')}: `}</Col>
                    <Col>
                      {lastTransactions ?
                        `${numberWithCommas(lastTransactions.trade_30d)} ${t(baseTokenSymbol)}` :
                        <Skeleton width={100} />
                      }
                    </Col>
                  </Row>
                </div>
                <div className="d-flex flex-column flex-1">
                  <Row className="mb-2">
                    <Col className="text-black-50">{`${t('24h Fiat Deposit')}: `}</Col>
                    <Col>
                      {lastTransactions ?
                        `${numberWithCommas(lastTransactions.deposit_24h.fiat)} ${t(baseTokenSymbol)} 
                        ${userGroup ? '/ ' + this.getLimits(this.getFiatLimits().deposit.max_24h) : null}` :
                        <Skeleton width={100} />
                      }
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{`${t('24h Crypto Deposit')}: `}</Col>
                    <Col>
                      {lastTransactions ?
                        `${numberWithCommas(lastTransactions.deposit_24h.crypto)} ${t(baseTokenSymbol)} 
                        ${userGroup ? '/ ' + this.getLimits(this.getCryptoLimits().deposit.max_24h) : null}` :
                        <Skeleton width={100} />
                      }
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{`${t('24h Fiat Withdrawal')}: `}</Col>
                    <Col>
                      {lastTransactions ?
                        `${numberWithCommas(lastTransactions.withdraw_24h.fiat)} ${t(baseTokenSymbol)} 
                        ${userGroup ? '/ ' + this.getLimits(this.getFiatLimits().withdraw.max_24h) : null}` :
                        <Skeleton width={100} />
                      }
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{`${t('24h Crypto Withdrawal')}: `}</Col>
                    <Col>
                      {lastTransactions ?
                        `${numberWithCommas(lastTransactions.withdraw_24h.crypto)} ${t(baseTokenSymbol)} 
                        ${userGroup ? '/ ' + this.getLimits(this.getCryptoLimits().withdraw.max_24h) : null}` :
                        <Skeleton width={100} />
                      }
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{`${t('30d Fiat Deposit')}: `}</Col>
                    <Col>
                      {lastTransactions ?
                        `${numberWithCommas(lastTransactions.deposit_30d.fiat)} ${t(baseTokenSymbol)} 
                        ${userGroup ? '/ ' + this.getLimits(this.getFiatLimits().deposit.max_30d) : null}` :
                        <Skeleton width={100} />
                      }
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{`${t('30d Crypto Deposit')}: `}</Col>
                    <Col>
                      {lastTransactions ?
                        `${numberWithCommas(lastTransactions.deposit_30d.crypto)} ${t(baseTokenSymbol)} 
                        ${userGroup ? '/ ' + this.getLimits(this.getCryptoLimits().deposit.max_30d) : null}` :
                        <Skeleton width={100} />
                      }
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{`${t('30d Fiat Withdrawal')}: `}</Col>
                    <Col>
                      {lastTransactions ?
                        `${numberWithCommas(lastTransactions.withdraw_30d.fiat)} ${t(baseTokenSymbol)} 
                        ${userGroup ? '/ ' + this.getLimits(this.getFiatLimits().withdraw.max_30d) : null}` :
                        <Skeleton width={100} />
                      }
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{`${t('30d Crypto Withdrawal')}: `}</Col>
                    <Col>
                      {lastTransactions ?
                        `${numberWithCommas(lastTransactions.withdraw_30d.crypto)} ${t(baseTokenSymbol)} 
                        ${userGroup ? '/ ' + this.getLimits(this.getCryptoLimits().withdraw.max_30d) : null}` :
                        <Skeleton width={100} />
                      }
                    </Col>
                  </Row>
                </div>
              </Row>
              <Separator className="my-4"/>
              <Row className='user-account-info d-flex flex-row text-medium'>
                <div className='col-12 col-lg-7 col-xl-7'>
                  <Row className="mb-2">
                    <Col className="text-black-50">{t('Google Authenticator')}</Col>
                    <Col className={authStatus && authStatus.googleAuthEnabled ? 'text-success' : 'text-danger'}>
                      {authStatus ?
                        <Switch
                          className="ltr"
                          disabled={!Rbac.hasPermission('update_twoFA')}
                          onChange={this.onChangeGoogleAuth}
                          checked={authStatus.googleAuthEnabled}
                          height={22}
                          width={45}
                        /> :
                        <Skeleton width={60} />}
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{t('SMS Authenticator')}</Col>
                    <Col className={authStatus && authStatus.smsAuthEnabled ? 'text-success' : 'text-danger'}>
                      {authStatus ?
                        <Switch
                          className="ltr"
                          disabled={!Rbac.hasPermission('update_twoFA')}
                          onChange={this.onChangeSmsAuth}
                          checked={authStatus.smsAuthEnabled}
                          height={22}
                          width={45}
                        /> :
                        <Skeleton width={60} />
                      }
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{t('Withdraw Status')}</Col>
                    <Col className={withdrawEnabled ? 'text-success' : 'text-danger'}>
                      {typeof withdrawEnabled === 'boolean' ?
                        <Switch
                          className="ltr"
                          disabled={!Rbac.hasPermission('update_user-settings')}
                          onChange={this.onChangeWithdrawStatus}
                          checked={withdrawEnabled}
                          height={22}
                          width={45}
                        /> :
                        <Skeleton width={60} />
                      }
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">
                      <div className='d-flex flex-row align-items-center'>
                        <span>{t('Withdraw Risk Management')}</span>
                        <ToolTip
                          id='withdrawRiskManagement'
                          text={<div className='d-flex flex-column'>
                            <div>{t('By activating or deactivating the withdrawal risk management, the 24-hour withdrawal limit will be activated or deactivated after the following activities:')}</div>
                            <ul>
                              <li>{t('First Deposit')}</li>
                              <li>{t('Change Email')}</li>
                              <li>{t('Change Mobile Number')}</li>
                            </ul>
                          </div>}>
                          <i className="icon-Information mx-1 text-one font-weight-semibold text-info"/>
                        </ToolTip>
                      </div>
                    </Col>
                    <Col className={withdrawRiskManagementEnabled ? 'text-success' : 'text-danger'}>
                      {typeof withdrawRiskManagementEnabled === 'number' ||  typeof withdrawRiskManagementEnabled === 'boolean' ?
                        <Switch
                          className="ltr"
                          disabled={!Rbac.hasPermission('update_user-settings')}
                          onChange={this.onChangeWithdrawRiskManagementStatus}
                          checked={!!withdrawRiskManagementEnabled}
                          height={22}
                          width={45}
                        /> :
                        <Skeleton width={60} />
                      }
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">
                      <div className='d-flex flex-row align-items-center'>
                        <span>{t('Withdraw Whitelist Status')}</span>
                        <ToolTip
                          id='withdrawWhitelistEnabled'
                          text={<div>{t('By activating this option, user crypto withdrawal will be unhindered')}</div>}>
                          <i className="icon-Information mx-1 text-one font-weight-semibold text-info"/>
                        </ToolTip>
                      </div>
                    </Col>
                    <Col className={withdrawWhitelistEnabled ? 'text-success' : 'text-danger'}>
                      {typeof withdrawWhitelistEnabled === 'number' ||  typeof withdrawWhitelistEnabled === 'boolean' ?
                        <Switch
                          className="ltr"
                          disabled={!Rbac.hasPermission('update_user-settings')}
                          onChange={this.onChangeWithdrawWhitelistStatus}
                          checked={!!withdrawWhitelistEnabled}
                          height={22}
                          width={45}
                        /> :
                        <Skeleton width={60} />
                      }
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">
                      <div className='d-flex flex-row align-items-center'>
                        <span>{t('Withdraw Risk After Deposit')}</span>
                        <ToolTip
                          id='withdrawRiskAfterDepositEnabled'
                          text={<div>{t('By activating this option, after depositing Tomans by the user, it will not be possible to withdraw the currency for the value of the deposited Tomans for 72 hours')}</div>}>
                          <i className="icon-Information mx-1 text-one font-weight-semibold text-info"/>
                        </ToolTip>
                      </div>
                    </Col>
                    <Col className={withdrawRiskAfterDepositEnabled ? 'text-success' : 'text-danger'}>
                      {typeof withdrawRiskAfterDepositEnabled === 'number' ||  typeof withdrawRiskAfterDepositEnabled === 'boolean' ?
                        <Switch
                          className="ltr"
                          disabled={!Rbac.hasPermission('update_user-settings')}
                          onChange={this.onChangeWithdrawRiskAfterDepositStatus}
                          checked={!!withdrawRiskAfterDepositEnabled}
                          height={22}
                          width={45}
                        /> :
                        <Skeleton width={60} />
                      }
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{t('Order Registration Status')}</Col>
                    <Col className={orderRegistrationEnabled ? 'text-success' : 'text-danger'}>
                      {typeof orderRegistrationEnabled === 'boolean' ?
                        <Switch
                          className="ltr"
                          disabled={!Rbac.hasPermission('update_user-settings')}
                          onChange={this.onChangeOrderRegistrationStatus}
                          checked={orderRegistrationEnabled}
                          height={24}
                          width={45}
                        /> :
                        <Skeleton width={60} />}
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="text-black-50">{t('Block User')}</Col>
                    <Col className={blocked ? 'text-success' : 'text-danger'}>
                      {typeof blocked === 'boolean' ?
                        <Switch
                          className="ltr"
                          disabled={!Rbac.hasPermission('update_user-suspension')}
                          onChange={this.onChangeBlockStatus}
                          checked={blocked}
                          height={24}
                          width={45}
                        /> :
                        <Skeleton width={60} />}
                    </Col>
                  </Row>
                </div>
                <div className='col-12 col-lg-5 col-xl-5'>
                  <Rbac permission='view_user-groups'>
                    <Row className='align-items-center my-3'>
                      <Col className="text-black-50 col-4">{t('User User-Group')}</Col>
                      <Col>
                        {userGroups && userGroup ?
                          <Select
                            className="w-75"
                            styles={selectStyles}
                            onChange={this.onChangeUserGroup}
                            value={{label: userGroup.name, value: userGroup.name}}
                            options={values(userGroups).map(obj => ({label: obj.name, value: obj.name}))}
                            isDisabled={!Rbac.hasPermission('update_user-policy')}
                            placeholder={t('Select')}
                          /> :
                          <Skeleton width={60} />}
                      </Col>
                    </Row>
                  </Rbac>
                  <Rbac permission='view_policies'>
                    <Row className='align-items-center my-3'>
                      <Col className="text-black-50 col-4">{t('User TradeFee-Policy')}</Col>
                      <Col>
                        {loyaltyPolicies && userGroup ?
                          <div className='d-flex flex-row align-items-center'>
                            <Select
                              className="w-75"
                              styles={selectStyles}
                              onChange={this.onChangeLoyaltyPolicy}
                              value={{
                                label: userGroup.attributes.loyalty_policy.name,
                                value: userGroup.attributes.loyalty_policy.id
                              }}
                              options={loyaltyPolicies.map(obj => ({label: obj.name, value: obj.id}))}
                              isDisabled={!Rbac.hasPermission('update_user-policy')}
                              placeholder={t('Select')}
                            />
                            {!!userGroups && !!userGroups[Number(userGroup.id)] &&
                              userGroup.attributes.loyalty_policy.id !== userGroups[Number(userGroup.id)].attributes.loyalty_id &&
                              <div className='mx-2'>
                                <ToolTip
                                  id='return_loyalty_default'
                                  text={t('Return to group default')}>
                                  <i
                                    className="icon-Back mx-2 text-large font-weight-semibold text-success cursor-pointer"
                                    onClick={async () => {
                                      await this.onChangeLoyaltyPolicy({
                                        value: userGroups[Number(userGroup.id)].attributes.loyalty_id}
                                      );
                                    }}
                                  />
                                </ToolTip>
                                <ToolTip
                                  id='user_loyalty_id'
                                  text={t('Contradiction with group default')}>
                                    <i className="icon-Information text-large font-weight-semibold text-warning"/>
                                </ToolTip>
                              </div>
                            }
                          </div> :
                          <Skeleton width={60} />
                        }
                      </Col>
                    </Row>
                  </Rbac>
                  <Rbac permission='view_policies'>
                    <Row className='align-items-center my-3'>
                      <Col className="text-black-50 col-4">{t('User Kyc-Policy')}</Col>
                      <Col>
                        {kycPolicies && userGroup ?
                          <div className='d-flex flex-row align-items-center'>
                            <Select
                              className="w-75"
                              styles={selectStyles}
                              onChange={this.onChangeKycPolicy}
                              value={{
                                label: userGroup.attributes.kyc_policy.name,
                                value: userGroup.attributes.kyc_policy.id
                              }}
                              options={kycPolicies.map(obj => ({label: obj.name, value: obj.id}))}
                              isDisabled={!Rbac.hasPermission('update_user-policy')}
                              placeholder={t('Select')}
                            />
                              {!!userGroups && !!userGroups[Number(userGroup.id)] &&
                                userGroup.attributes.kyc_policy.id !== userGroups[Number(userGroup.id)].attributes.kyc_id &&
                                <div className='mx-2'>
                                  <ToolTip
                                    id='return_kyc_default'
                                    text={t('Return to group default')}>
                                    <i
                                      className="icon-Back mx-2 text-large font-weight-semibold text-success cursor-pointer"
                                      onClick={async () => {
                                        await this.onChangeKycPolicy({
                                          value: userGroups[Number(userGroup.id)].attributes.kyc_id}
                                        );
                                      }}
                                    />
                                  </ToolTip>
                                  <ToolTip
                                    id='user_kyc_id'
                                    text={t('Contradiction with group default')}>
                                    <i className="icon-Information text-large font-weight-semibold text-warning cu"/>
                                  </ToolTip>
                                </div>
                              }
                          </div> :
                          <Skeleton width={60} />
                        }
                      </Col>
                    </Row>
                  </Rbac>
                </div>
              </Row>
              {(Rbac.hasPermission('view_user-special-tokens') ||
                Rbac.hasPermission('view_user-special-pairs')) &&
                <div>
                  {((!!specialTokens && specialTokens.length > 0) ||
                    (!!specialPairs && specialPairs.length > 0)) &&
                    <Separator className="my-3"/>
                  }
                  <Row className='text-medium mx-1'>
                    <Rbac permission='view_user-special-tokens'>
                      {!!specialTokens && specialTokens.length > 0 &&
                        <div className='col-12 col-lg-6 col-xl-6'>
                          <div>{t('User Special Tokens')}</div>
                          {userSpecialTokens ?
                            <Select
                              className="w-75"
                              isMulti
                              styles={selectStyles}
                              onChange={this.onChangeUserSpecialTokens}
                              value={userSpecialTokens.map(token => ({label: token, value: token}))}
                              options={specialTokens.map(token => ({label: token, value: token}))}
                              isDisabled={!Rbac.hasPermission('update_user-special-tokens')}
                              placeholder={t('Select')}
                            /> :
                            <Skeleton width={60}/>
                          }
                        </div>
                      }
                    </Rbac>
                    <Rbac permission='view_user-special-pairs'>
                      {!!specialPairs && specialPairs.length > 0 &&
                        <div className='col-12 col-lg-6 col-xl-6'>
                          <div>{t('User Special Pairs')}</div>
                          {userSpecialPairs ?
                            <Select
                              className="w-75"
                              isMulti
                              styles={selectStyles}
                              onChange={this.onChangeUserSpecialPairs}
                              value={userSpecialPairs.map(pair => ({label: pair, value: pair}))}
                              options={specialPairs.map(pair => ({label: pair, value: pair}))}
                              isDisabled={!Rbac.hasPermission('update_user-special-pairs')}
                              placeholder={t('Select')}
                            />
                            :
                            <Skeleton width={60}/>
                          }
                        </div>
                      }
                    </Rbac>
                  </Row>
                </div>
              }
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default withTranslation()(Profile);
